/* MISÜ 2026-10-22 — Cartes produits : pastilles de coloris (portage BBP bbdp-card-extras.js, « option B »).
   Toucher une pastille fait basculer la carte sur ce coloris (photo, nom, prix, liens, cœur, badge)
   sans quitter la page ; la première pastille ramène au produit d'origine.
   Toucher la pastille déjà active ouvre la fiche du coloris affiché.
   Avec le titre sur deux lignes (snippets/misu-card-title.liquid), seule la couleur et le prix changent.
   Chaque toucher envoie l'événement misu_swatch_click dans le dataLayer.
   Aucune requête réseau : tout est déjà dans les attributs des pastilles (snippets/misu-swatch.liquid).
   Les pastilles de la fiche produit (.misu-pdp-swatches) ne sont pas interceptées : ce sont de simples liens. */
(function () {
  if (window.__misuSwatches) return;
  window.__misuSwatches = true;

  function setLastText(node, value) {
    if (!node || !value) return;
    for (var i = node.childNodes.length - 1; i >= 0; i--) {
      var child = node.childNodes[i];
      if (child.nodeType === 3 && child.textContent.trim() !== '') {
        child.textContent = value;
        return;
      }
    }
    if (!node.children.length) node.textContent = value;
  }

  function remember(img) {
    if (img.hasAttribute('data-misu-orig')) return;
    img.setAttribute('data-misu-orig', '1');
    img.setAttribute('data-misu-orig-src', img.getAttribute('src') || '');
    img.setAttribute('data-misu-orig-srcset', img.getAttribute('srcset') || '');
  }

  function swapImages(card, sw, toOrigin) {
    var gallery = card.querySelector('[ref="cardGallery"]') || card.querySelector('.card-gallery');
    if (!gallery) return;
    var imgs = gallery.querySelectorAll('img.product-media__image');
    var src = sw.getAttribute('data-misu-img');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      remember(img);
      if (toOrigin) {
        img.setAttribute('src', img.getAttribute('data-misu-orig-src'));
        img.setAttribute('srcset', img.getAttribute('data-misu-orig-srcset'));
      } else if (src) {
        img.removeAttribute('loading');
        img.setAttribute('srcset', sw.getAttribute('data-misu-srcset') || src);
        img.setAttribute('src', src);
      }
    }
    if (toOrigin) gallery.removeAttribute('data-misu-switched');
    else gallery.setAttribute('data-misu-switched', '');
  }

  function apply(card, sw, row) {
    var href = sw.getAttribute('href');
    var title = sw.getAttribute('data-misu-title') || '';
    var toOrigin = row && sw.getAttribute('data-misu-swatch') === row.getAttribute('data-misu-from');

    swapImages(card, sw, toOrigin);

    var heading = card.querySelector('[ref="productTitleLink"] [role="heading"]');
    var finish = heading && heading.querySelector('.misu-ctitle__finish');
    if (finish) {
      // Titre sur deux lignes : seule la couleur change (le modèle et le type sont communs à la gamme)
      finish.textContent = sw.getAttribute('data-misu-finish') || '';
    } else if (heading && title) {
      heading.textContent = title;
    }
    var zoomTitle = card.querySelector('.product-grid-view-zoom-out--details h3');
    if (zoomTitle && title) zoomTitle.textContent = title;

    var price = sw.getAttribute('data-misu-price');
    var compare = sw.getAttribute('data-misu-compare');
    var prices = card.querySelectorAll('product-price .price');
    for (var p = 0; p < prices.length; p++) setLastText(prices[p], price);
    var amount = card.querySelector('[data-misu-ctitle-price] .misu-ctitle__amount');
    if (amount && price) amount.textContent = price;
    var cmp = card.querySelector('[data-misu-ctitle-price] .misu-ctitle__compare');
    if (cmp) { cmp.textContent = compare || ''; cmp.hidden = !compare; }
    if (compare) {
      var compares = card.querySelectorAll('product-price .compare-at-price');
      for (var c = 0; c < compares.length; c++) setLastText(compares[c], compare);
    }

    var links = card.querySelectorAll('[ref="productCardLink"], [ref="cardGalleryLink"], [ref="productTitleLink"]');
    for (var l = 0; l < links.length; l++) {
      links[l].setAttribute('href', href);
      if (links[l].hasAttribute('aria-label')) links[l].setAttribute('aria-label', title);
    }

    var wish = card.querySelector('.misu-card-wish');
    if (wish) {
      wish.setAttribute('data-handle', sw.getAttribute('data-misu-swatch'));
      wish.setAttribute('data-id', sw.getAttribute('data-misu-id') || '');
      if (window.MisuWishlist) window.MisuWishlist.refresh();
    }

    var badge = card.querySelector('span.misu-card-badge');
    if (badge) {
      var data = sw.getAttribute('data-misu-badge') || '';
      var parts = data.split('|');
      badge.className = 'misu-badge misu-card-badge' + (data ? ' misu-badge--' + parts[0] : '');
      badge.textContent = data ? parts.slice(1).join('|') : '';
      badge.hidden = !data;
    }

    var all = card.querySelectorAll('[data-misu-swatches] [data-misu-swatch]');
    for (var j = 0; j < all.length; j++) all[j].removeAttribute('aria-current');
    sw.setAttribute('aria-current', 'true');
  }

  /* Phase de capture : passe avant le clic de la carte produit Horizon. */
  document.addEventListener(
    'click',
    function (event) {
      var sw = event.target && event.target.closest && event.target.closest('[data-misu-swatches] [data-misu-swatch]');
      if (!sw) return;
      var row = sw.closest('[data-misu-swatches]');
      var card = sw.closest('product-card');
      var active = sw.getAttribute('aria-current') === 'true';

      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'misu_swatch_click',
          misu_swatch_from: row ? row.getAttribute('data-misu-from') : '',
          misu_swatch_to: sw.getAttribute('data-misu-swatch'),
          misu_swatch_action: active || !card ? 'ouvre_fiche' : 'change_carte'
        });
      } catch (e) {}

      if (active || !card) {
        event.stopPropagation(); // le lien de la pastille ouvre la fiche
        return;
      }
      event.preventDefault();
      event.stopPropagation();
      apply(card, sw, row);
    },
    true
  );
})();
